.nest-panel {
  @apply flex
    flex-col
    flex-auto
    border-r
    w-full
    min-h-[calc(100vh-theme(spacing.16))]
  ;

  &__content {
    @apply
    min-w-[240px]
    h-auto
    overflow-hidden
  }
}

.nest-panel-header {
  @apply bg-white px-10 py-4 border-b;

  &__title {}

  &__description {
    @apply text-sm text-gray-400;
  }
}

